import { AfterViewInit, Component, OnInit } from '@angular/core';
import { SalesMailRank } from './rank.model';
import { RankService } from './rank.service';


export type SalesMailRankPanel = {
  rank: SalesMailRank,
  onImage: string;
  offImage: string;
};

@Component({
    selector: 'app-rank',
    templateUrl: './rank.component.html',
    styleUrls: ['./rank.component.scss'],
    standalone: false
})
export class RankComponent implements OnInit, AfterViewInit {

  isLoading: boolean = true;
  currentRank: SalesMailRank | undefined;  
  views: number | undefined;
  rankPanels: SalesMailRankPanel[] = [
    {
      rank: 'Apprentice',
      onImage: '/assets/images/rank/Apprentice_On.svg',
      offImage: '/assets/images/rank/Apprentice_Off.svg'
    },
    {
      rank: 'Intermediate',
      onImage: '/assets/images/rank/Intermediate_On.svg',
      offImage: '/assets/images/rank/Intermediate_Off.svg'
    },
    {
      rank: 'Pro',
      onImage: '/assets/images/rank/Pro_On.svg',
      offImage: '/assets/images/rank/Pro_Off.svg'
    },
    {
      rank: 'Guru',
      onImage: '/assets/images/rank/Guru_On.svg',
      offImage: '/assets/images/rank/Guru_Off.svg'
    },
  ];

  needleTransform = 'translateX(-50%) rotate(90deg)'; //Default pointed at max
  
  constructor(private rankService: RankService) {}

  ngOnInit(): void {
    this.getRank();
  }

  ngAfterViewInit(): void {    
    
  }
  
  async getRank() {
    try {
      this.isLoading = true;

      const result = await this.rankService.getUserRank();
      this.currentRank = result.rank.display;
      
      const viewData = result.data.filter(d => d.type == 'View');
      if (viewData && viewData.length > 0) {
        this.views = viewData[0].total;
      } else {
        this.views = 0;
      }
    } catch (error) {
      console.error(error);      
    }

    this.isLoading = false;

    const animationDuration = 500;
    setTimeout(() => {
      this.animateToTarget(0); // Sweep to left before showing actual value
      setTimeout(() => {
        this.animateToTarget(this.views);
      }, animationDuration); // animate to actual value
    }, animationDuration);
    

  }

  getValueAngle(value: number): number {
    if (value > 500) return 90;
    if (value === 0) return -90;
    if (value <= 24) return -45;
    if (value <= 99) return 0;
    if (value <= 499) return 45;
    return 90;
  }

  animateToTarget(value: number) {
    const angle = this.getValueAngle(value); 
    this.needleTransform = `translateX(-50%) rotate(${angle}deg)`;     
  }

}
